import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVerification } from '../context/VerificationContext';
import { useAuth } from '../hooks/useAuth';

export default function VerificationModeToggle() {
  const { enabled, toggle, hiddenCount } = useVerification();
  const { isAdmin } = useAuth();
  const { t } = useTranslation();

  // Toggle vizibil DOAR pentru admini. Userii plătitori normali nu văd
  // butonul — conținut nu dispare neexplicat sub ei.
  if (!isAdmin || !isAdmin()) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={enabled}
      title={enabled
        ? t('app.verification_toggle.title_on')
        : t('app.verification_toggle.title_off')}
      style={{
        position: 'fixed',
        left: 18,
        bottom: 18,
        zIndex: 9999,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 14px',
        borderRadius: 999,
        border: enabled ? '1px solid #2d6a4f' : '1px solid rgba(13,27,42,0.18)',
        background: enabled ? '#2d6a4f' : '#ffffff',
        color: enabled ? '#ffffff' : '#0d1b2a',
        fontFamily: 'DM Mono, monospace',
        fontSize: 11,
        letterSpacing: 2,
        textTransform: 'uppercase',
        cursor: 'pointer',
        boxShadow: '0 8px 24px rgba(13,27,42,0.18)',
      }}
    >
      <span
        aria-hidden
        style={{
          width: 10, height: 10, borderRadius: '50%',
          background: enabled ? '#a7f3d0' : '#cbd5e1',
          boxShadow: enabled ? '0 0 0 3px rgba(167,243,208,0.3)' : 'none',
          transition: 'background 200ms ease',
        }}
      />
      {t('app.verification_toggle.label', { state: enabled ? 'ON' : 'OFF' })}
      {enabled && hiddenCount > 0 && (
        <span
          style={{
            marginLeft: 4,
            padding: '2px 8px',
            borderRadius: 999,
            background: 'rgba(255,255,255,0.18)',
            fontSize: 10,
          }}
        >
          {t('app.verification_toggle.hidden_count', { count: hiddenCount })}
        </span>
      )}
    </button>
  );
}
